<template>
  <a-config-provider :locale="locale">
    <div class="form-designer-container-9136076486841527" v-if="loadState">
      <k-header v-if="showHead" :title.sync="title" />
      <!-- 操作区域 start -->
      <operatingArea
        v-if="toolbarsTop"
        :showToolbarsText="showToolbarsText"
        :toolbars="toolbars"
        @handleSave="handleSave"
        @handlePreview="handlePreview"
        @handleOpenImportJsonModal="handleOpenImportJsonModal"
        @handleOpenCodeModal="handleOpenCodeModal"
        @handleOpenJsonModal="handleOpenJsonModal"
        @handleSaveHistory="handleSaveHistory"
        @handleGenerateItemNumber="handleGenerateItemNumber"
        @handleReset="handleReset"
        @handleClose="handleClose"
        @handleUndo="handleUndo"
        @handleRedo="handleRedo"
        :kDesignType="kDesignType"
        :projectId="projectId"
      >
        <template slot="left-action">
          <slot name="left-action"></slot>
        </template>

        <template slot="right-action">
          <slot name="right-action"></slot>
        </template>
      </operatingArea>
      <!-- 操作区域 end -->
      <div
        class="content"
        :class="{
          'show-head': showHead,
          'toolbars-top': toolbarsTop,
          'show-head-and-toolbars-top': toolbarsTop && showHead
        }"
      >
        <!-- 左侧控件区域 start -->
        <aside class="left">
          <a-tabs
            :activeKey="leftActiveKey"
            @change="leftChangeTab"
            :tabBarStyle="{ margin: 0, textAlign: 'center'}"
          >
            <a-tab-pane :key="1" tab="表单">
              <csimFormRetrieve
                ref="CsimFormRetrieve"
                :config="data.config"
                :previewOptions="previewOptions"
                @handleSetSelectForm="handleSetSelectForm"
                :kDesignType="kDesignType"
                :projectId="projectId"
              />
            </a-tab-pane>
            <a-tab-pane :key="2" tab="题型">
              <a-collapse
                v-if="selectForm.id !== ''"
                @change="collapseChange"
                :defaultActiveKey="collapseDefaultActiveKey"
              >
                <!-- 基础控件 start -->
                <a-collapse-panel
                  v-for="(item, index) in schemaGroup"
                  :header="item.title"
                  :key="index"
                >
                  <collapseItem
                    :list="item.list"
                    @generateKey="generateKey"
                    @handleListPush="handleListPush"
                    @start="handleStart"
                  />
                </a-collapse-panel>
                <!-- 基础控件 end -->
              </a-collapse>
              <a-empty
                v-if="selectForm.id === ''"
                class="hint-box"
                description="请先选择表单"
              />
            </a-tab-pane>
          </a-tabs>
        </aside>
        <!-- 左侧控件区域 end -->

        <!-- 中间面板区域 start -->
        <section>
          <!-- 操作区域 start -->
          <operatingArea
            v-if="!toolbarsTop"
            :showToolbarsText="showToolbarsText"
            :toolbars="toolbars"
            @handleSave="handleSave"
            @handlePreview="handlePreview"
            @handleOpenImportJsonModal="handleOpenImportJsonModal"
            @handleOpenCodeModal="handleOpenCodeModal"
            @handleOpenJsonModal="handleOpenJsonModal"
            @handleSaveHistory="handleSaveHistory"
            @handleGenerateItemNumber="handleGenerateItemNumber"
            @handleReset="handleReset"
            @handleClose="handleClose"
            @handleUndo="handleUndo"
            @handleRedo="handleRedo"
            :kDesignType="kDesignType"
            :projectId="projectId"
          >
            <template slot="left-action">
              <slot name="left-action"></slot>
            </template>

            <template slot="right-action">
              <slot name="right-action"></slot>
            </template>
          </operatingArea>
          <!-- 操作区域 end -->
          <k-form-component-panel
            :class="{ 'no-toolbars-top': !toolbarsTop }"
            :data="data"
            :selectItem="selectItem"
            :selectForm="selectForm"
            :noModel="noModel"
            :hideModel="hideModel"
            :hideTypeModel="hideTypeModel"
            :startType="startType"
            ref="KFCP"
            @handleSetSelectItem="handleSetSelectItem"
            @handleRelation="openParentChildRelationModal"
            @refreshOptions="refreshOptions"
            :kDesignType="kDesignType"
            :projectId="projectId"
          />
          <!-- 操作区域 start -->
          <k-json-modal ref="jsonModal" />
          <k-code-modal ref="codeModal" />
          <importJsonModal ref="importJsonModal" />
          <k-form-preview ref="previewModal" />
          <parent-child-relation-modal ref="parentChildRelationModal" @save="handleParentChildRelationSave" />
        </section>
        <!-- 中间面板区域 end -->

        <!-- 右侧控件属性区域 start -->
        <aside class="right">
          <a-tabs
            :activeKey="activeKey"
            @change="changeTab"
            :tabBarStyle="{ margin: 0, textAlign: 'center'}"
          >
            <a-tab-pane :key="1" tab="表单属性">
              <csimFormProperties
                v-if="selectForm.id !== ''"
                :selectItem="selectItem"
                :selectForm="selectForm"
                :previewOptions="previewOptions"
                @handlePreview="handlePreview"
                @reloadFormList="reloadFormList"
                @reloadSelectForm="reloadSelectForm"
                :kDesignType="kDesignType"
                :projectId="projectId"
              />
              <a-empty
                v-if="selectForm.id === ''"
                class="hint-box"
                description="请先选择表单"
              />
            </a-tab-pane>
            <a-tab-pane :key="2" tab="题目属性">
              <csimFormAttribute
                v-if="selectForm.id !== ''"
                class="form-item-properties"
                :selectItem="selectItem"
                :parentItem="parentItem"
                :selectForm="selectForm"
                :hideModel="hideModel"
                :hideTypeModel="hideTypeModel"
                @refreshOptions="refreshOptions"
                :kDesignType="kDesignType"
                :projectId="projectId"
              />
              <a-empty
                v-if="selectForm.id === ''"
                class="hint-box"
                description="请先选择表单"
              />
            </a-tab-pane>
          </a-tabs>
        </aside>
        <!-- 右侧控件属性区域 end -->
      </div>
      <!-- <k-footer /> -->

      <a-modal :title="saveHistoryTitle" :width="600" :visible="saveHistoryVisible" @ok="handleHistorySave" @cancel="handleCancelHistory" cancelText="取消">
        <div>
          <span>在保存历史前，<strong style="color: red;">请确保已经保存了当前表单</strong>，是否保存当前版本为历史？</span>
        </div>
        <div style="margin-top: 10px;">
          <a-textarea :rows="3" placeholder="请输入保存历史描述" v-model="saveHistoryDescription" />
        </div>
      </a-modal>

      <a-modal :title="generateItemNumberTitle" :width="600" :visible="generateItemNumberVisible" @ok="handleGenerateItemNumberSave" @cancel="handleCancelGenerateItemNumber" cancelText="取消">
        <div>
          <span>在自动生成题号前，<strong style="color: red;">请确保已经保存了当前表单</strong>，确认使用自动生成题号吗？</span>
        </div>
      </a-modal>
    </div>
  </a-config-provider>
</template>
<script>
/*
 * author kcz
 * date 2019-11-20
 * description 表单设计器
 */
import kHeader from "./module/header";
import operatingArea from "./module/operatingArea";

// import kFooter from "./module/footer";
import kFormComponentPanel from "./module/formComponentPanel";
import kJsonModal from "./module/jsonModal";
import kCodeModal from "./module/codeModal";
import collapseItem from "./module/collapseItem";
import importJsonModal from "./module/importJsonModal";
import KFormPreview from "../KFormPreview/index.vue";
import zhCN from "ant-design-vue/lib/locale-provider/zh_CN";
import { Modal, message } from "ant-design-vue";
import { revoke, nodeSchema, eraseUtils } from "../../utils/index";
import csimFormAttribute from "./module/csimFormAttribute";
import csimFormProperties from "./module/csimFormProperties";
import csimFormRetrieve from "./module/csimFormRetrieve";
import ParentChildRelationModal from './module/ParentChildRelationModal.vue';

import { getAction, putAction, postAction } from '@/api/manage'

export default {
  name: "KFormDesign",
  props: {
    title: {
      type: String,
      default: "表单设计器 -- Refiny"
    },
    showHead: {
      type: Boolean,
      default: true
    },
    hideResetHint: {
      type: Boolean,
      default: false
    },
    toolbarsTop: {
      type: Boolean,
      default: false
    },
    toolbars: {
      type: Array,
      default: () => [
        "save",
        "preview",
        "importJson",
        "exportJson",
        "exportCode",
        "reset",
        "close",
        "undo",
        "redo",
        "saveHistory"
      ]
    },
    showToolbarsText: {
      type: Boolean,
      default: false
    },
    hideModel: {
      // 隐藏数据字段
      type: Boolean,
      default: false
    },
    hideTypeModel: {
      // 隐藏数据字段
      type: Boolean,
      default: false
    },
    kDesignType:{
      type:String,
      default:''
    },
    projectId:{
      type:String,
      default:''
    },
  },
  data() {
    return {
      locale: zhCN,
      loadState: false,
      activeKey: 1,
      leftActiveKey: 1,
      updateTime: 0,
      updateRecordTime: 0,
      startType: "",
      noModel: [
        "button",
        "divider",
        "card",
        "selectCard",
        "grid",
        "tabs",
        "table",
        "alert",
        "text",
        "html"
      ],
      schemaGroup: [],
      data: {
        form: {},
        list: [],
        config: {
          layout: "vertical",
          labelCol: { xs: 4, sm: 4, md: 4, lg: 4, xl: 4, xxl: 4 },
          labelWidth: 100,
          labelLayout: "flex",
          wrapperCol: { xs: 18, sm: 18, md: 18, lg: 18, xl: 18, xxl: 18 },
          hideRequiredMark: false,
          customStyle: ""
        }
      },
      previewOptions: {
        width: 850
      },
      selectItem: {
        key: ""
      },
      parentItem: {
        key: ""
      },
      selectForm: {
        id: "",
        code: ""
      },
      saveHistoryTitle: "保存历史",
      saveHistoryDescription: "",
      saveHistoryVisible: false,
      confirmLoading: false,
      generateItemNumberTitle: "自动生成题号",
      generateItemNumberVisible: false,
    };
  },
  components: {
    kHeader,
    // kFooter,
    operatingArea,
    collapseItem,
    kJsonModal,
    kCodeModal,
    importJsonModal,
    KFormPreview,
    kFormComponentPanel,
    csimFormAttribute,
    csimFormProperties,
    csimFormRetrieve,
    ParentChildRelationModal: () => import('./module/ParentChildRelationModal.vue')
  },
  watch: {
    data: {
      handler(e) {
        this.$nextTick(() => {
          revoke.push(e);
        });
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    collapseDefaultActiveKey() {
      // 计算当前展开的控件列表
      const defaultActiveKey = window.localStorage.getItem(
        "collapseDefaultActiveKey"
      );
      if (defaultActiveKey) {
        return defaultActiveKey.split(",");
      } else {
        return ["1"];
      }
    }
  },
  methods: {
    generateKey(list, index) {
      // 生成key值
      const key = list[index].type + "_" + new Date().getTime();
      this.$set(list, index, {
        ...list[index],
        key,
        model: key
      });
      if (this.noModel.includes(list[index].type)) {
        // 删除不需要的model属性
        delete list[index].model;
      }
    },
    handleListPush(item) {
      // 双击控件按钮push到list
      // 生成key值
      if (!this.selectItem.key) {
        // 在没有选择表单时，将数据push到this.data.list
        const key = item.type + "_" + new Date().getTime();
        item = {
          ...item,
          key,
          model: key
        };
        if (this.noModel.includes(item.type)) {
          // 删除不需要的model属性
          delete item.model;
        }
        const itemString = JSON.stringify(item);
        const record = JSON.parse(itemString);
        // 删除icon及compoent属性
        delete record.icon;
        delete record.component;
        
        // 自动计算序号并设置
        const nextSequence = this.data.list.length + 1;
        record.sequence = nextSequence.toString();
        
        // 确保common对象存在并设置sortNum
        if (!record.common) {
          record.common = {};
        }
        record.common.sortNum = nextSequence;
        
        this.data.list.push(record);
        this.handleSetSelectItem(record);
        return false;
      }
      this.$refs.KFCP.handleCopy(false, item);
    },
    handleOpenJsonModal() {
      // 打开json预览模态框
      this.$refs.jsonModal.jsonData = this.data;
      this.$refs.jsonModal.visible = true;
    },
    handleOpenCodeModal() {
      // 打开代码预览模态框
      this.$refs.codeModal.jsonData = this.data;
      this.$refs.codeModal.visible = true;
    },
    handleOpenImportJsonModal() {
      // 打开json预览模态框
      this.$refs.importJsonModal.jsonData = this.data;
      this.$refs.importJsonModal.handleSetSelectItem = this.handleSetSelectItem;
      this.$refs.importJsonModal.visible = true;
    },
    handlePreview() {
      // 打开预览模态框
      this.$refs.previewModal.jsonData = this.data;
      this.$refs.previewModal.previewWidth = this.previewOptions.width;
      this.$refs.previewModal.visible = true;
    },
    handleReset() {
      // 清空
      if (this.hideResetHint) {
        // 不显示提示直接清空
        this.resetData();
        return;
      }

      Modal.confirm({
        title: "警告",
        content: "是否确认清空内容?",
        okText: "是",
        okType: "danger",
        cancelText: "否",
        onOk: () => {
          this.resetData();
        }
      });
    },
    resetData() {
      this.data = {
        form: this.selectForm,
        list: [],
        config: {
          layout: "vertical",
          labelCol: { xs: 4, sm: 4, md: 4, lg: 4, xl: 4, xxl: 4 },
          labelWidth: 100,
          labelLayout: "flex",
          wrapperCol: { xs: 18, sm: 18, md: 18, lg: 18, xl: 18, xxl: 18 },
          hideRequiredMark: false,
          customStyle: ""
        }
      };
      this.handleSetSelectItem({ key: "" });
      this.$refs.CsimFormRetrieve.reset();
      // message.success("已清空");
    },
    handleSetSelectItem(record) {
      console.log('handleSetSelectItem---111',record)
      if (!record) {
        return;
      }
      // 操作间隔不能低于100毫秒
      const newTime = new Date().getTime();
      if (newTime - this.updateTime < 100) {
        return false;
      }

      var parent = eraseUtils.getParentNode(this.data, record.key);
      if(!parent){
        parent = eraseUtils.getParentNode2(this.data, record.key);
      }
      this.parentItem = parent

      this.updateTime = newTime;

      // 设置selectItem的值
      this.selectItem = record;

      // 判断是否选中控件，如果选中则弹出属性面板，否则关闭属性面板
      if (record.key) {
        this.startType = record.type;
        this.changeTab(2);
      } else {
        this.changeTab(1);
      }
    },

    reloadSelectForm(func) {
      let that = this;
      if (this.kDesignType === 'PROJECT_FORM') {
        getAction('/project/projectForm/getInfoById',{id: this.selectForm.id}).then(res=>{
          if(res.success){
            that.handleSetSelectForm(res.result);
            if (func) {
              that.$nextTick(()=>{
                func();
              })
            }
          }
        })
      } else if (this.kDesignType === 'CONFIG_FORM' || this.kDesignType === 'SCHEMA_DESIGN') {
        getAction('/tempconfig/tempConfigForm/getInfoByCode',{code:this.selectForm.code}).then(res=>{
          if(res.success){
            this.handleSetSelectForm(res.result);
            if (func) {
              func();
            }
          }
        })
      }
    },

    resetAllData() {
      this.selectItem = {
        key: ""
      };
      this.parentItem = {
        key: ""
      };
      this.selectForm = {
        id: "",
        code: ""
      };

      this.resetData();
    },

    handleSetSelectForm(record) { 
      let that = this;
      this.selectForm = record;
      this.data.form = this.selectForm;
      this.$emit("updateTitle", record.name);

      let status = '';

      if (this.kDesignType === 'PROJECT_FORM') {
        if (record.status === '1') {
          status = "正常";
        } else if (record.status === '0') {
          status = "停用";
        }
      } else if (this.kDesignType === 'CONFIG_FORM' || this.kDesignType === 'SCHEMA_DESIGN') {
        if((record.status&15)==15){
          status += ' 已完成';
        }else{
          status += ' 已新增';
          if((record.status&2)==2){
            status += ' 已导入';
          }
          if((record.status&8)==8){
            status += ' 已附件';
          }
          if((record.status&4)==4){
            status += ' 已分类';
          }
        }        
            
        if((record.status&16)==16){
          status += ' 已审核';
        }
        if((record.status&32)==32){
          status += ' 已上线';
        }
      }

      this.$emit("updateStatus", status);

      if (this.kDesignType === 'PROJECT_FORM') {
        getAction('/project/projectFormItem/listByFormId', { 
          column: "sortNum,createTime",
          order: "asc,asc",
          formId: record.id,
          field: "id,name,number,required_dictText,scale_dictText,conceal_dictText,parentValue,category,sortNum,action2,action",
          pageSize: 500, 
          pageNo: 1
        }).then(res => {
          if (res.success) {
            that.data.list = eraseUtils.parseFormItemsData(res.result);

            that.data.config = eraseUtils.formDefaultConfig();

            that.selectItem = {
              key: ''
            }
          } else {
            that.$message.error('后台请求异常')
          }
        })
      } else if (this.kDesignType === 'CONFIG_FORM' || this.kDesignType === 'SCHEMA_DESIGN') {
        getAction('/tempconfig/tempConfigFormItem/list', { 
          column: 'createTime', 
          order: 'desc', 
          formCode: record.code, 
          field: 'id,name,number,sortNum,action', 
          pageSize: 500, 
          pageNo: 1
        }).then(res => {
          if (res.success) {
            that.data.list = eraseUtils.parseFormItemsData(res.result);
            that.data.config = eraseUtils.formDefaultConfig();

            that.selectItem = {
              key: ''
            }
          } else {
            that.$message.error('后台请求异常')
          }
        })
      }
    },
    /**
     * @description: 切换属性设置面板
     * @param {*}
     * @return {*}
     */

    changeTab(e) {
      this.activeKey = e;
    },

    leftChangeTab(e) {
      this.leftActiveKey = e;
    },
    /**
     * @Author: kcz
     * @description: 遍历json结构，获取所有字段
     * @param {*}
     * @return {*} Array
     */
    getFieldSchema() {
      const fields = [];
      const traverse = array => {
        array.forEach(element => {
          if (element.type === "grid" || element.type === "tabs") {
            // 栅格布局
            element.columns.forEach(item => {
              traverse(item.list);
            });
          } else if (element.type === "card" || element.type === 'selectCard' || element.type === 'emptyCard') {
            // 卡片布局
            traverse(element.list);
          } else if (element.type === "batch") {
            // 动态表格内复制
            traverse(element.list);
          } else if (element.type === "table") {
            // 表格布局
            element.trs.forEach(item => {
              item.tds.forEach(val => {
                traverse(val.list);
              });
            });
          } else {
            if (element.model) {
              fields.push(element);
            }
          }
        });
      };
      traverse(this.data.list);
      return fields;
    },
    handleSetData(data) {
      // 用于父组件赋值
      try {
        if (typeof data !== "object") {
          return false;
        } else {
          this.data = data;
          // 导入json数据后，需要清除已选择key
          this.handleSetSelectItem({ key: "" });
        }
        return true;
      } catch (error) {
        console.error(error);
        return false;
      }
    },
    collapseChange(val) {
      // 点击collapse时，保存当前collapse状态
      window.localStorage.setItem("collapseDefaultActiveKey", val);
    },
    handleStart(type) {
      this.startType = type;
    },

    /**
     * @description: 撤销
     * @param {*}
     * @return {*}
     */
    handleUndo() {
      const record = revoke.undo();
      if (!record) {
        return false;
      }
      this.data = record;

      this.handleSetSelectItem({ key: "" });
    },

    /**
     * @description: 重做
     * @param {*}
     * @return {*}
     */
    handleRedo() {
      const record = revoke.redo();
      if (!record) {
        return false;
      }
      this.data = record;
    },

    handleSave() {
      // 保存函数   
      this.$emit("submit", JSON.stringify(this.data));
    },
    
    getValue() {
      // 获取数据
      return this.data;
    },
    handleClose() {
      this.$emit("close");
    },
    refreshOptions() {
      var parent = eraseUtils.getParentNode(this.data, this.selectItem.key);
      if(!parent){
        parent = eraseUtils.getParentNode2(this.data, this.selectItem.key);
      }
      this.parentItem = parent
    },
    
    // 检查selectItem是否正确引用到data中的对象
    checkSelectItemInData() {
      // console.log('Checking if selectItem is correctly referenced in data');
      const foundItem = this.findItemInData(this.data.list, this.selectItem.key);
      if (foundItem) {
        // console.log('Found selectItem in data, item:', foundItem);
        // console.log('Comparing selectItem and foundItem:');
        // console.log('selectItem === foundItem:', this.selectItem === foundItem);
        // console.log('selectItem.common:', this.selectItem.common);
        // console.log('foundItem.common:', foundItem.common);
      } else {
        // console.log('selectItem not found in data');
      }
    },
    
    // 在数据中查找指定key的项
    findItemInData(items, key) {
      if (!items || !Array.isArray(items)) return null;
      
      for (let item of items) {
        if (item.key === key) {
          return item;
        }
        
        // 递归查找嵌套结构
        let found = null;
        if (item.list && Array.isArray(item.list)) {
          found = this.findItemInData(item.list, key);
          if (found) return found;
        }
        
        if (item.columns && Array.isArray(item.columns)) {
          for (let column of item.columns) {
            if (column.list && Array.isArray(column.list)) {
              found = this.findItemInData(column.list, key);
              if (found) return found;
            }
          }
        }
        
        if (item.trs && Array.isArray(item.trs)) {
          for (let tr of item.trs) {
            if (tr.tds && Array.isArray(tr.tds)) {
              for (let td of tr.tds) {
                if (td.list && Array.isArray(td.list)) {
                  found = this.findItemInData(td.list, key);
                  if (found) return found;
                }
              }
            }
          }
        }
      }
      
      return null;
    },

    reloadFormList() {
      this.$emit('reloadFormList');
    },
// ------------------------------------------------------------------------
    handleSaveHistory() {
      if (!this.selectForm.id) {
        this.$message.warning("无数据可用于保存历史。");
        return;
      }

      this.saveHistoryVisible = true;
    },

    handleHistorySave() {
      this.confirmLoading = true
      putAction('/project/projectFormVersion/create',{
        projectId: this.projectId,
        formId: this.selectForm.id,
        description: this.saveHistoryDescription
      }).then(res=>{
        if(res.success){
          this.$message.success(res.message)
        }else{
          this.$message.error(res.message)
        }
      }).catch(e=>{
        this.$message.error('未知异常'+e)
      }).finally(()=>{
        this.confirmLoading = false
        this.saveHistoryVisible = false;
      })
    },
    
    // 处理父子题关系保存
    handleParentChildRelationSave(relationData) {
      console.log('handleParentChildRelationSave called, relationData:', relationData);
      console.log('this.selectItem', this.selectItem);
      
      // 更新当前选中项的父子题关系
      if (!this.selectItem) {
        console.log('selectItem is null or undefined');
        return;
      }
      
      // 检查relationData
      if (!relationData) {
        console.log('relationData is null or undefined');
        return;
      }
      console.log('relationData:', relationData);
      
      // 确保selectItem是data中的原始对象引用
      const actualSelectItem = this.findItemInData(this.data.list, this.selectItem.key) || this.selectItem;
      console.log('actualSelectItem:', actualSelectItem);
      console.log('selectItem === actualSelectItem:', this.selectItem === actualSelectItem);
      
      // 确保actualSelectItem存在
      if (!actualSelectItem) {
        console.log('actualSelectItem is null or undefined');
        return;
      }
      
      // 设置父题的code
      const parentQuestions = this.getParentQuestions();
      console.log('Available parent questions:', parentQuestions);
      
      if (!relationData.parentQuestion) {
        console.log('relationData.parentQuestion is missing');
        return;
      }
      
      const selectedParentQuestion = parentQuestions.find(q => q.key === relationData.parentQuestion);
      if (selectedParentQuestion) {
        // 确保common对象存在
        if (!actualSelectItem.common) {
          actualSelectItem.common = {};
        }
        actualSelectItem.common.parentCode = selectedParentQuestion.code;
        // 检查selectItem是否正确引用到data中的对象
        this.checkSelectItemInData();
      } else {
        console.log('No matching parent question found for key:', relationData.parentQuestion);
        console.log('Available keys:', parentQuestions.map(q => q.key));
      }
      
      // 设置父题选项值
      // 确保common对象存在
      if (!actualSelectItem.common) {
        actualSelectItem.common = {};
      }
      actualSelectItem.common.parentValue = relationData.parentOptions ? relationData.parentOptions.join(',') : '';
      
      // 触发刷新
      this.refreshOptions();
      
      // 确保common对象在数据中的引用一致性
      // 更新data.list中的实际对象，确保引用正确
      const itemInData = this.findItemInData(this.data.list, actualSelectItem.key);
      if (itemInData && itemInData !== actualSelectItem) {
        // 如果引用不一致，需要确保data中的对象也被更新
        if (!itemInData.common) {
          itemInData.common = {};
        }
        itemInData.common.parentCode = actualSelectItem.common.parentCode;
        itemInData.common.parentValue = actualSelectItem.common.parentValue;
      }
      
      // 调用formComponentPanel的updateSequenceNumbers方法更新序号
      if (this.$refs.KFCP && typeof this.$refs.KFCP.updateSequenceNumbers === 'function') {
        this.$refs.KFCP.updateSequenceNumbers();
      }
    },
    
    // 获取可作为父题的题目列表（sortNum小于当前题目的无父题题目）
    getParentQuestions(currentItem) {
      const questions = [];
      
      // 递归遍历表单中的所有题目
      const traverse = (items) => {
        items.forEach(item => {
          // 检查基本条件
          if (!item.label || 
              ['grid', 'table', 'selectInputList', 'tabs', 'card', 'selectCard', 'editor', 'batch', 'divider', 'html'].includes(item.type)) {
            return;
          }
                    
          // 父题类型只能是单选或者多选
          if(item.type !== 'checkbox' && item.type !== 'radio'){ 
             // console.log('Skipping item (not checkbox or radio):', item.type, item.key);
              return;
          }
                  
          // 检查是否有父题（有parentCode表示该题已经是子题，不能作为父题）
          // if (item.common && item.common.parentCode) {
          //   return;
          // }
          
          // 检查item的sortNum
          let itemSortNum = 0;  
          // 检查currentItem的sortNum
          let currentSortNum = Infinity;
          
          // 检查item的sortNum
          if (item.common && item.common.sortNum !== undefined && item.common.sortNum !== null) {
            itemSortNum = parseFloat(item.common.sortNum);
            if (isNaN(itemSortNum)) {
              itemSortNum = 0;
            }
          } else {
            itemSortNum = 0;
          }
          
          // 检查currentItem的sortNum
          if (currentItem && currentItem.common && currentItem.common.sortNum !== undefined && currentItem.common.sortNum !== null) {
            currentSortNum = parseFloat(currentItem.common.sortNum);
            if (isNaN(currentSortNum)) {
              currentSortNum = Infinity;
            }
          } else {
            currentSortNum = Infinity;
          }
          
           console.log('itemSortNum:', itemSortNum, 'currentSortNum:', currentSortNum);
          if (itemSortNum < currentSortNum) {
            // 构建questionObj对象
            const questionObj = {
              key: item.key,
              label: item.label,
              sortNum: item.common && item.common.sortNum !== undefined ? item.common.sortNum : (item.sortNum !== undefined ? item.sortNum : 0),
              type: item.type,
              code: item.common && item.common.code ? item.common.code : '',
              options: item.options && item.options.options ? item.options.options : [],
              common: item.common,
              number:item.sequence ,
            };
            //console.log('Adding question to parent list:', questionObj);
            questions.push(questionObj);
          } else {
            // console.log('Skipping item (sortNum not less than current):', item.key);
          }
          
          // 递归处理嵌套结构
          if (item.list && Array.isArray(item.list)) {
            traverse(item.list);
          }
          
          if (item.columns && Array.isArray(item.columns)) {
            item.columns.forEach(column => {
              if (column.list && Array.isArray(column.list)) {
                traverse(column.list);
              }
            });
          }
          
          if (item.trs && Array.isArray(item.trs)) {
            item.trs.forEach(tr => {
              if (tr.tds && Array.isArray(tr.tds)) {
                tr.tds.forEach(td => {
                  if (td.list && Array.isArray(td.list)) {
                    traverse(td.list);
                  }
                });
              }
            });
          }
        });
      };
      
      if (this.data && this.data.list) {
        console.log('Traversing data.list',this.data.list);
        traverse(this.data.list);
      }
      
      console.log('getParentQuestions returning:', questions);
      return questions;
    },
    
    // 打开父子题关系设置弹窗
    openParentChildRelationModal(record) {
      if (!record) {
        return;
      }
      
      // 检查record是否与data中的对象是同一个引用
      const foundItem = this.findItemInData(this.data.list, record.key);
      if (foundItem) {
        // console.log('record === foundItem:', record === foundItem);
      }
      
      // 如果record不是data中的原始对象引用，则使用data中的对象
      const actualRecord = foundItem || record;
      
      // 设置当前选中项
      this.handleSetSelectItem(actualRecord);
      
      // 输出当前题目的信息
      // console.log('Current item info:', {
      //   key: actualRecord.key,
      //   label: actualRecord.label,
      //   sequence: actualRecord.sequence,
      //   type: actualRecord.type,
      //   common: actualRecord.common
      // });
      
      // 获取表单中所有可作为父题的题目（sortNum小于当前题目的无父题题目）
      const parentQuestions = this.getParentQuestions(actualRecord);
      // console.log('parentQuestions:', parentQuestions);
      
      // 打开弹窗
      if (this.$refs.parentChildRelationModal) {
        this.$refs.parentChildRelationModal.show(parentQuestions, actualRecord);
      } else {
        console.error('parentChildRelationModal ref is not available');
      }
    },
    handleCancelHistory() {
      this.saveHistoryVisible = false;
    },
// ------------------------------------------------------------------------
    handleGenerateItemNumber() {
      if (!this.selectForm.id) {
        this.$message.warning("无数据可用于自动生成题号。");
        return;
      }

      this.generateItemNumberVisible = true;
    },

    handleGenerateItemNumberSave() {
      this.confirmLoading = true
      postAction('/project/projectFormItem/resetNum',{ formId: this.selectForm.id }).then(res=>{
        if(res.success){
          this.$emit("refreshForm");
        }
      }).finally(()=>{
        this.confirmLoading = false
        this.generateItemNumberVisible = false;
      })
    },
    handleCancelGenerateItemNumber() {
      this.generateItemNumberVisible = false;
    },
    resetSeletedFormId(formInfo) {
      // console.log("resetSeletedFormInfo: ", formInfo);

      if (this.kDesignType === 'SCHEMA_DESIGN') {
        this.handleSetSelectForm(formInfo);
      }
    }
  },
  created() {
    this.loadState = true;
    nodeSchema.addComputed(this.schemaGroup);
    this.schemaGroup = nodeSchema.getSchemaByGroup();
  }
};
</script>
